import { useMutation } from '@tanstack/react-query';

import { useSupabase } from './use-supabase';

interface VerifyPhoneOtpParams {
  phone: string;
  token: string;
  type: 'sms';
}

export function useVerifyPhoneOtp() {
  const client = useSupabase();

  const mutationKey = ['verify-phone-otp'];

  const mutationFn = async (params: VerifyPhoneOtpParams) => {
    const { data, error } = await client.auth.verifyOtp(params);

    if (error) {
      throw error;
    }

    return data;
  };

  return useMutation({
    mutationFn,
    mutationKey,
  });
}
